import React from "react";

import { relativeShort, TIME_WINDOWS, type TimeWindow } from "../../utils/operationsDashboard";

interface OperationsToolbarProps {
  value: TimeWindow;
  onChange: (next: TimeWindow) => void;
  onRefresh: () => void;
  isRefreshing?: boolean;
  /** One stamp for the whole board — every widget is drawn from the same fetch. */
  updatedAt?: string | null;
  className?: string;
}

// The datasets page's eai-seg strip: one range for the whole page, since two widgets on two ranges contradict each other
const OperationsToolbar: React.FC<OperationsToolbarProps> = ({
  value,
  onChange,
  onRefresh,
  isRefreshing = false,
  updatedAt = null,
  className = "",
}) => (
  <div className={`flex flex-wrap items-center gap-3 ${className}`}>
    <div className="eai-seg max-w-full overflow-x-auto" role="group" aria-label="Time range">
      {TIME_WINDOWS.map((option) => {
        const active = option.id === value.id;
        return (
          <button
            key={option.id}
            type="button"
            onClick={() => onChange(option)}
            className={`eai-seg-item whitespace-nowrap ${active ? "eai-seg-item-active" : ""}`}
            aria-current={active ? "true" : undefined}
          >
            {option.label}
          </button>
        );
      })}
    </div>

    <button type="button" onClick={onRefresh} disabled={isRefreshing} className="eai-btn-outline">
      {isRefreshing && (
        <div className="h-3.5 w-3.5 animate-spin rounded-full border border-eai-ink-muted border-t-transparent motion-reduce:animate-none" />
      )}
      {isRefreshing ? "Refreshing…" : "Refresh"}
    </button>

    {/* Beside the control that changes it — a stale board that looks live is the worst failure here */}
    <span className="font-inter text-eai-body-xs text-eai-ink-faint">
      {updatedAt
        ? `Updated ${relativeShort(new Date(updatedAt).getTime(), Date.now()).toLowerCase()}`
        : "Not yet loaded"}
    </span>
  </div>
);

export default OperationsToolbar;
